import { render, staticRenderFns } from "./NewEvent.vue?vue&type=template&id=9e842c88&scoped=true&"
import script from "./NewEvent.vue?vue&type=script&lang=js&"
export * from "./NewEvent.vue?vue&type=script&lang=js&"
import style0 from "./NewEvent.vue?vue&type=style&index=0&id=9e842c88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e842c88",
  null
  
)

export default component.exports